/**
 * Меняем ?event в запросах при переходе на страницу,
 * связанную с другим мероприятием
 */

const middleware: NuxtMiddleware = ({ params, store }) => {
  let customEvent = params.eventAlias || ""
  if (customEvent === "undefined") customEvent = ""
  store.commit("app/SET_CUSTOM_EVENT", customEvent)
}

export default middleware
